import {
  Facet,
  FacetOption,
  FacetsAdapterResult,
  BaseOption,
} from '../../../collaborators/fetch-products/new-contract/types';
import config, { defaultConfig } from '../../config';

// With the new contract the type value became the selection type so was necessary to map
// to the old value.
const getType = (type: string) =>
  type === 'single-select' || type === 'multi-select' ? 'simple' : type;

const mapOption = (option: FacetOption, name: string): BaseOption => {
  const baseOption: BaseOption = {
    ...option,
    id: option.name,
    value: option.name,
    name: option.localeName,
    isActive: 'true',
  };

  if (name === 'color') {
    baseOption.value = option.localeName;
  }

  return baseOption;
};

const getAppliedValues = (options: any) => {
  const values = Array.isArray(options) ? options : [];
  return values.filter((value) => value.applied && value.isActive === 'true');
};

export default (facets: Facet[]): FacetsAdapterResult => {
  const facetOptions: FacetOption[] = facets
    .filter((facet) => getType(facet.type) === 'simple')
    .map((facet: Facet) => {
      const options = facet.options?.map((option) =>
        mapOption(option, facet.name)
      );
      const facetData = {
        ...defaultConfig,
        ...(config[facet.name] ?? {}),
        name: facet.name,
        type: getType(facet.type),
        localizedName: facet.localeName,
        displayName: facet.localeName,
        isActive: facet.isActive,
        options,
      };
      return { ...facetData, appliedValues: getAppliedValues(options) };
    });

  const hasTags = facetOptions?.some((facet) =>
    facet.options?.some((option) => option.applied)
  );
  return { hasTags, facetOptions };
};
